module.exports = __webpack_public_path__ + "img/24.4.NH3-N.932be68e.png";